<div
  class="rr-header row w100 space-between align-center"
  *ngIf="showDialogHeader === true"
>
  <h2>Your Landingpage</h2>
  <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
</div>

<!DOCTYPE html>
<html lang="en" id="internl_landingpage">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>ideastream.io</title>
    <!-- <style>
      body {
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        line-height: 1.6;
        color: #333;
      }
      h1 {
        color: white;
      }
      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
      }

      /* Header */
      .header {
        background: #0a2640;
        padding: 1rem 0;
        position: sticky;
        width: 100%;
        top: 0;
        z-index: 1000;
      }

      .nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .logo {
        color: white;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .nav-links {
        display: flex;
        list-style: none;
        gap: 2rem;
      }

      .nav-links a {
        color: white;
        text-decoration: none;
        transition: color 0.3s;
      }

      .nav-links a:hover {
        color: #65e4a3;
      }

      .login-btn {
        background: white;
        color: #0a2640;
        padding: 0.5rem 1.5rem;
        border: none;
        border-radius: 25px;
        cursor: pointer;
        font-weight: 600;
      }

      /* Hero Section */
      .hero {
        background: #0a2640;
        color: white;
        padding: 120px 0 80px;
        min-height: 100vh;
        display: flex;
        align-items: center;
      }

      .hero-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4rem;
        align-items: center;
      }

      .hero-text h1 {
        font-size: 3rem;
        margin-bottom: 1.5rem;
        line-height: 1.2;
      }

      .hero-text p {
        font-size: 1.1rem;
        margin-bottom: 2rem;
        opacity: 0.9;
      }

      .hero-buttons {
        display: flex;
        gap: 1rem;
      }

      .btn-primary {
        background: #65e4a3;
        color: #0a2640;
        padding: 1rem 2rem;
        border: none;
        border-radius: 25px;
        font-weight: 600;
        cursor: pointer;
        transition: transform 0.3s;
      }

      .btn-primary:hover {
        transform: translateY(-2px);
      }

      .btn-secondary {
        background: transparent;
        color: white;
        padding: 1rem 2rem;
        border: 2px solid white;
        border-radius: 25px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s;
      }

      .btn-secondary:hover {
        background: white;
        color: #0a2640;
      }

      .hero-image {
        border-radius: 10px;
        overflow: hidden;
        height: 400px;
      }

      .hero-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      /* Services Section */
      .services {
        padding: 80px 0;
        background: white;
      }

      .section-header {
        text-align: center;
        margin-bottom: 4rem;
      }

      .section-header p {
        color: #777;
        margin-bottom: 1rem;
      }

      .section-header h2 {
        font-size: 2.5rem;
        color: #0a2640;
      }

      .services-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 3rem;
      }

      .service-card {
        text-align: center;
        padding: 2rem;
      }

      .service-icon {
        width: 80px;
        height: 80px;
        background: #65e4a3;
        border-radius: 50%;
        margin: 0 auto 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        color: white;
        overflow: hidden;
      }

      .service-icon img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .service-card h3 {
        font-size: 1.5rem;
        margin-bottom: 1rem;
        color: #0a2640;
      }

      /* Features Section */
      .features {
        padding: 80px 0;
      }

      .feature {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4rem;
        align-items: center;
        margin-bottom: 6rem;
      }

      .feature:nth-child(even) .feature-content {
        order: 2;
      }

      .feature:nth-child(even) .feature-image {
        order: 1;
      }

      .feature-content h3 {
        font-size: 2rem;
        margin-bottom: 1.5rem;
        color: #0a2640;
      }

      .feature-list {
        list-style: none;
        margin: 2rem 0;
      }

      .feature-list li {
        padding: 0.5rem 0;
        position: relative;
        padding-left: 2rem;
      }

      .feature-list li:before {
        content: "✓";
        position: absolute;
        left: 0;
        color: #65e4a3;
        font-weight: bold;
      }

      .feature-image {
        border-radius: 10px;
        height: 300px;
        overflow: hidden;
      }

      .feature-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      /* Big Image Section */
      .big-image-section {
        padding: 0;
        margin: 80px 0;
      }

      .big-image {
        width: 100%;
        height: 500px;
        overflow: hidden;
        border-radius: 20px;
        position: relative;
      }

      .big-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .big-image-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          135deg,
          rgba(10, 38, 64, 0.8),
          rgba(101, 228, 163, 0.3)
        );
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        text-align: center;
      }

      .big-image-content h2 {
        font-size: 3rem;
        margin-bottom: 1rem;
      }

      .big-image-content p {
        font-size: 1.2rem;
        max-width: 600px;
      }

      /* Testimonials */
      .testimonials {
        background: #0a2640;
        color: white;
        padding: 80px 0;
      }

      .testimonial-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 3rem;
      }

      .testimonial-card {
        background: rgba(255, 255, 255, 0.1);
        padding: 2rem;
        border-radius: 10px;
      }

      .testimonial-text {
        font-size: 1.1rem;
        margin-bottom: 1.5rem;
        font-style: italic;
      }

      .testimonial-author {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .author-avatar {
        width: 50px;
        height: 50px;
        background: #65e4a3;
        border-radius: 50%;
        overflow: hidden;
      }

      .author-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      /* CTA Section */
      .cta {
        background: #0a2640;
        color: white;
        padding: 80px 0;
        text-align: center;
      }

      .cta h2 {
        font-size: 2.5rem;
        margin-bottom: 2rem;
      }

      .cta-buttons {
        display: flex;
        gap: 1rem;
        justify-content: center;
        flex-wrap: wrap;
      }

      .email-input {
        padding: 1rem 2rem;
        border: none;
        border-radius: 25px;
        margin-right: 1rem;
        min-width: 300px;
        font-size: 1rem;
      }

      /* Footer */
      .footer {
        background: #0a2640;
        color: white;
        padding: 40px 0;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
      }

      .footer-content {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 2rem;
      }

      .footer-section h4 {
        margin-bottom: 1rem;
        color: #65e4a3;
      }

      .footer-section ul {
        list-style: none;
      }

      .footer-section ul li {
        margin-bottom: 0.5rem;
      }

      .footer-section ul li a {
        color: white;
        text-decoration: none;
        opacity: 0.8;
        transition: opacity 0.3s;
      }

      .footer-section ul li a:hover {
        opacity: 1;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .nav-links {
          display: none;
        }

        .hero-content {
          grid-template-columns: 1fr;
          text-align: center;
        }

        .hero-text h1 {
          font-size: 2rem;
        }

        .feature {
          grid-template-columns: 1fr;
        }

        .feature:nth-child(even) .feature-content,
        .feature:nth-child(even) .feature-image {
          order: unset;
        }

        .hero-buttons,
        .cta-buttons {
          flex-direction: column;
          align-items: center;
        }

        .email-input {
          min-width: 250px;
          margin-right: 0;
          margin-bottom: 1rem;
        }

        .big-image {
          height: 300px;
        }

        .big-image-content h2 {
          font-size: 2rem;
        }

        .big-image-content p {
          font-size: 1rem;
        }
      }
    </style> -->
  </head>
  <body>
    <!-- Header -->
    <header class="header">
      <nav class="nav container">
        <div class="logo">🔥 {{ jd?.companyName }}</div>
        <ul class="nav-links" *ngIf="showDialogHeader === false">
          <li><a routerLink="./" fragment="home">Home</a></li>
          <li><a routerLink="./" fragment="about">About</a></li>
          <li><a routerLink="./" fragment="services">Services</a></li>
          <li><a routerLink="./" fragment="contact">Contact</a></li>
        </ul>
        <ul class="nav-links" *ngIf="showDialogHeader === true">
          <li>Home</li>
          <li>About</li>
          <li>Services</li>
          <li>Contact</li>
        </ul>
        <button class="login-btn">Log In</button>
      </nav>
    </header>

    <!-- Hero Section -->
    <section class="hero" id="home" #home>
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <h1>{{ jd?.heroHeadline }}</h1>
            <p>
              {{ jd?.heroDescription }}
            </p>
            <div class="hero-buttons">
              <button class="btn-primary">{{ jd?.heroButton1 }}</button>
              <button class="btn-secondary">{{ jd?.geroButton2 }}</button>
            </div>
          </div>
          <div class="hero-image">
            <img src="/lp-images/hero-graphics.png" alt="Dashboard Analytics" />
          </div>
        </div>
      </div>
    </section>

    <!-- Offer Section -->
    <section class="services" id="services" #service>
      <div class="container">
        <div class="section-header">
          <!--<p>Our Product</p>-->
          <h2>{{ jd?.offerHeadline }}</h2>
        </div>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">
              <img src="/lp-images/1.png" alt="Business Strategy" />
            </div>
            <h3>{{ jd?.offeringTitle1 }}</h3>
            <p>
              {{ jd?.offeringTitle1Subheadline }}
            </p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img src="/lp-images/1.png" alt="Target Marketing" />
            </div>
            <h3>{{ jd?.offeringTitle2 }}</h3>
            <p>
              {{ jd?.offeringTitle2Subheadline }}
            </p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img src="/lp-images/1.png" alt="Innovation" />
            </div>
            <h3>{{ jd?.offeringTitle3 }}</h3>
            <p>
              {{ jd?.offeringTitle3Subheadline }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Features & Solution Section -->
    <section class="features" #features>
      <div class="container">
        <div class="section-header">
          <p>{{ jd?.features }}</p>
          <!--<h2>Handshake infographic mass market crowdfunding iteration</h2>-->
        </div>
        <div class="feature">
          <div class="feature-content">
            <h3>
              {{ jd?.featuresHeadline }}
            </h3>
            <ul class="feature-list">
              <li>{{ jd?.feature1 }}</li>
              <li>{{ jd?.feature2 }}</li>
              <li>{{ jd?.feature3 }}</li>
            </ul>
          </div>
          <div class="feature-image">
            <img src="/lp-images/2.png" alt="Team Collaboration" />
          </div>
        </div>
      </div>
    </section>
    <section class="features">
      <div class="container">
        <div class="section-header">
          <p>{{ jd?.solution }}</p>
          <!--<h2>Handshake infographic mass market crowdfunding iteration</h2>-->
        </div>
        <div class="feature">
          <div class="feature-image">
            <img src="/lp-images/2-1.png" alt="Data Analytics" />
          </div>
          <div class="feature-content">
            <h3>
              {{ jd?.solutionHeadline }}
            </h3>
            <ul class="feature-list">
              <li>{{ jd?.solution1 }}</li>
              <li>{{ jd?.solution2 }}</li>
              <li>{{ jd?.solution3 }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Section -->
    <section class="testimonials">
      <div class="container">
        <div class="section-header">
          <h2 style="color: white">{{ jd?.testimonials }}</h2>
        </div>
        <div class="testimonial-grid">
          <div class="testimonial-card">
            <div class="testimonial-text">"{{ jd?.testimonial1 }}"</div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <img src="/lp-images/2-2.png" alt="Albus Dumbledore" />
              </div>
              <div>
                <div>{{ jd?.testimonial1Name }}</div>
                <div style="opacity: 0.7; font-size: 0.9rem">
                  {{ jd?.testimonial1Position }}
                </div>
              </div>
            </div>
          </div>
          <div class="testimonial-card">
            <div class="testimonial-text">"{{ jd?.testimonial2 }}"</div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <img src="/lp-images/2-2.png" alt="Severus Snape" />
              </div>
              <div>
                <div>{{ jd?.testimonial2Name }}</div>
                <div style="opacity: 0.7; font-size: 0.9rem">
                  {{ jd?.testimonial2Position }}
                </div>
              </div>
            </div>
          </div>
          <div class="testimonial-card">
            <div class="testimonial-text">"{{ jd?.testimonial3 }}"</div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <img src="/lp-images/2-2.png" alt="Harry Potter" />
              </div>
              <div>
                <div>{{ jd?.testimonial3Name }}</div>
                <div style="opacity: 0.7; font-size: 0.9rem">
                  {{ jd?.testimonial3Position }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Big Image Section -->
    <section class="big-image-section">
      <div class="container">
        <div class="big-image">
          <img src="/lp-images/3-1.png" alt="Modern Office Space" />
          <div class="big-image-overlay">
            <div class="big-image-content">
              <h2>{{ jd?.bigImageSection }}</h2>
              <!--<p>Leverage cutting-edge technology and innovative solutions to accelerate your company's growth and success in the digital marketplace.</p>-->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Value Proposition Section -->
    <section class="services" style="background: #f8f9fa" id="about" #about>
      <div class="container">
        <div class="section-header">
          <h2>{{ jd?.valuePropositionHeadline }}</h2>
        </div>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon" style="background: #4a90e2">
              <img src="/lp-images/3.png" alt="Growth Analytics" />
            </div>
            <h3>{{ jd?.serviceCard1Name }}</h3>
            <p>{{ jd?.serviceCard1Description }}</p>
          </div>
          <div class="service-card">
            <div class="service-icon" style="background: #ff6b6b">
              <img src="/lp-images/3-1.png" alt="Enterprise Solutions" />
            </div>
            <h3>{{ jd?.serviceCard2Name }}</h3>
            <p>{{ jd?.serviceCard2Description }}</p>
          </div>
          <div class="service-card">
            <div class="service-icon" style="background: #4ecdc4">
              <img src="/lp-images/3-2.png" alt="Innovation Lab" />
            </div>
            <h3>{{ jd?.serviceCard3Name }}</h3>
            <p>{{ jd?.serviceCard3Description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Final CTA Section -->
    <section class="cta" id="contact" #contact>
      <div class="container">
        <h2>{{ jd?.finalCTAHeadline }}</h2>
        <div class="cta-buttons">
          <input
            type="email"
            placeholder="Your email address"
            class="email-input"
          />
          <button class="btn-primary">{{ jd?.finalCTAButton }}</button>
        </div>
      </div>
    </section>
  </body>
</html>
